// extracted by mini-css-extract-plugin
export default {"title":"styles_title__MwWMK","navigationContainer":"styles_navigationContainer__fP2nK","navigationList":"styles_navigationList__2TCX7"};